var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        key: _vm.resetTab,
        attrs: {
          title: "Emisión por lotes",
          breadcrumbs: _vm.breadcrumbs,
          hiddenTab: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u(
          [
            _vm.$helpers.hasSomePermission(["view_batch"])
              ? {
                  key: "main",
                  fn: function () {
                    return [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            outlined: "",
                            disabled: !_vm.batchesList.length,
                          },
                          on: {
                            click: function ($event) {
                              ;(_vm.isLoadMore = true),
                                (_vm.isUpdate = true),
                                _vm.getList()
                            },
                          },
                        },
                        [
                          _c("v-img", {
                            attrs: {
                              contain: "",
                              src: require(`@/assets/icon-update${
                                _vm.$vuetify.theme.dark ? "-dark" : ""
                              }.svg`),
                            },
                          }),
                        ],
                        1
                      ),
                      _c("v-query-builder", {
                        staticClass: "mr-2",
                        attrs: {
                          "query-map": _vm.filters,
                          model: "documents",
                          active: _vm.activeFilter,
                        },
                        on: {
                          "update:active": function ($event) {
                            _vm.activeFilter = $event
                          },
                        },
                      }),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            ripple: false,
                            outlined: "",
                            disabled: !_vm.batchesList?.length,
                          },
                          on: {
                            click: function ($event) {
                              _vm.dialogExport = true
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v("mdi-download"),
                          ]),
                          _vm._v("Descargar"),
                        ],
                        1
                      ),
                      _vm.$helpers.hasSomePermission(["add_batch"])
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "grey-900", ripple: false },
                              on: {
                                click: function ($event) {
                                  _vm.dialogCreate = true
                                },
                              },
                            },
                            [
                              _c("v-icon", { attrs: { left: "" } }, [
                                _vm._v("mdi-plus-box"),
                              ]),
                              _vm._v("Crear proceso"),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                }
              : null,
            _vm.$helpers.hasSomePermission(["view_batch"])
              ? {
                  key: "custom-tab",
                  fn: function () {
                    return [
                      _vm.$helpers.hasSomePermission(["view_batch"])
                        ? _c(
                            "v-tabs",
                            {
                              staticClass: "mt-n3 pt-8 pl-4 pr-5 background",
                              staticStyle: {
                                position: "absolute",
                                "z-index": "0 !important",
                              },
                              attrs: { height: 35 },
                              model: {
                                value: _vm.filter,
                                callback: function ($$v) {
                                  _vm.filter = $$v
                                },
                                expression: "filter",
                              },
                            },
                            _vm._l(_vm.stepperList, function (status) {
                              return _c(
                                "v-tab",
                                { key: status.id, attrs: { ripple: false } },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", small: "" } },
                                    [_vm._v("mdi-" + _vm._s(status.icon))]
                                  ),
                                  _vm._v(_vm._s(status.title) + " "),
                                  status.title === "Todas" ? void 0 : _vm._e(),
                                ],
                                2
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _c(
        "v-col",
        { staticClass: "pa-0 mt-25" },
        [
          !_vm.$helpers.hasSomePermission(["view_batch"])
            ? _c("PermissionDenied")
            : _c(
                "v-col",
                { staticClass: "px-0" },
                [
                  _vm.loading
                    ? _c("skeleton-list")
                    : [
                        (!_vm.batchesList?.length && !_vm.$route.query.ref) ||
                        (!_vm.batchesList?.length && _vm.$route.query.ref) ||
                        !_vm.batchesList?.length
                          ? _c("v-empty-state", {
                              attrs: {
                                type: "el",
                                id: "procesos de emisión por lote",
                                title:
                                  "No hay procesos de emisión por lote para mostrar",
                                isFree: !(_vm.hiddenBtnEmpty && _vm.isCreated),
                                hiddenDescription:
                                  _vm.hiddenBtnEmpty && _vm.isCreated,
                                height: 220,
                                customClass: "mt-1",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "actions",
                                    fn: function () {
                                      return [
                                        !_vm.$route.query.ordering &&
                                        _vm.hiddenBtnEmpty &&
                                        _vm.isCreated
                                          ? [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "grey-900",
                                                    ripple: false,
                                                    width: 153,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.activeFilter = true
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { staticClass: "mr-2" },
                                                    [_vm._v("mdi-filter-plus")]
                                                  ),
                                                  _vm._v("Filtrar"),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "ml-2",
                                                  attrs: {
                                                    outlined: "",
                                                    ripple: false,
                                                    width: "153",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.$router.push({
                                                        query: {
                                                          ref: "initial",
                                                        },
                                                      }),
                                                        (_vm.isCreated = false)
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { staticClass: "mr-2" },
                                                    [
                                                      _vm._v(
                                                        "mdi-text-search-variant"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v("Últimos registros"),
                                                ],
                                                1
                                              ),
                                            ]
                                          : _vm._e(),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                4051146455
                              ),
                            })
                          : _c(
                              "v-col",
                              { staticClass: "px-0" },
                              [
                                _c("v-simple-table", {
                                  class: [
                                    {
                                      "fixed-table":
                                        _vm.$store.state.base
                                          .isExpandNavigationDrawer,
                                    },
                                  ],
                                  attrs: {
                                    height: _vm.heightTable,
                                    "fixed-header": "",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function () {
                                        return [
                                          _c("VTableHeaders", {
                                            attrs: { headers: _vm.headers },
                                            on: { sort: _vm.setSort },
                                          }),
                                          _c("v-divider", {
                                            staticStyle: {
                                              position: "absolute",
                                              "margin-top": "-6px",
                                              "min-width": "100%",
                                              "margin-left": "-5px",
                                              "z-index": "2",
                                            },
                                          }),
                                          _c(
                                            "tbody",
                                            { key: _vm.resetScroll },
                                            _vm._l(
                                              _vm.batchesList,
                                              function (item, i) {
                                                return _c(
                                                  "tr",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "intersect",
                                                        rawName: "v-intersect",
                                                        value:
                                                          i + 1 ===
                                                          _vm.batchesList
                                                            ?.length
                                                            ? _vm.loadMore
                                                            : "",
                                                        expression:
                                                          "(i + 1) === batchesList?.length ? loadMore : ''",
                                                      },
                                                    ],
                                                    key: i,
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.goTo(
                                                          item.batch_id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "td",
                                                      { staticClass: "body-2" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.batch_id)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "body-2 text-end",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.file_name)
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "body-2 text-end",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "dateTimeSecond"
                                                            )(item.created)
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "body-2 text-end",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "dateTimeSecond"
                                                            )(item.updated)
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "body-2 text-end",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$fmt.integer(
                                                              item.quantity
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "td",
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: {
                                                              color: "white-0",
                                                              right: "",
                                                              transition:
                                                                "scale-transition",
                                                              "max-width": 280,
                                                              "open-on-hover":
                                                                item.status_message
                                                                  ? true
                                                                  : false,
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "v-chip",
                                                                        _vm._g(
                                                                          {
                                                                            staticClass:
                                                                              "scroll",
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  _vm.stepperList.find(
                                                                                    ({
                                                                                      status,
                                                                                    }) =>
                                                                                      status.includes(
                                                                                        item.status
                                                                                      )
                                                                                  )
                                                                                    .color,
                                                                                small:
                                                                                  "",
                                                                                label:
                                                                                  "",
                                                                              },
                                                                          },
                                                                          item.status_message
                                                                            ? on
                                                                            : false
                                                                        ),
                                                                        [
                                                                          _vm._v(
                                                                            " " +
                                                                              _vm._s(
                                                                                _vm.stepperList.find(
                                                                                  ({
                                                                                    status,
                                                                                  }) =>
                                                                                    status.includes(
                                                                                      item.status
                                                                                    )
                                                                                )
                                                                                  .title
                                                                              ) +
                                                                              " "
                                                                          ),
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  right:
                                                                                    "",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "mdi-" +
                                                                                  _vm._s(
                                                                                    _vm.stepperList.find(
                                                                                      ({
                                                                                        status,
                                                                                      }) =>
                                                                                        status.includes(
                                                                                          item.status
                                                                                        )
                                                                                    )
                                                                                      .icon
                                                                                  )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "d-block px-3 py-2",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.status_message
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-right",
                                                      },
                                                      [
                                                        _c(
                                                          "v-menu",
                                                          {
                                                            attrs: {
                                                              "close-on-click":
                                                                "",
                                                              "close-on-content-click":
                                                                "",
                                                              "offset-y": "",
                                                              left: "",
                                                              "nudge-left": 10,
                                                              "nudge-bottom": 10,
                                                              transition:
                                                                "slide-y-transition",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on,
                                                                    attrs,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        "v-btn",
                                                                        _vm._g(
                                                                          _vm._b(
                                                                            {
                                                                              staticClass:
                                                                                "mr-n4 scroll",
                                                                              attrs:
                                                                                {
                                                                                  text: "",
                                                                                  "x-small":
                                                                                    "",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    _vm.current =
                                                                                      item
                                                                                  },
                                                                              },
                                                                            },
                                                                            "v-btn",
                                                                            attrs,
                                                                            false
                                                                          ),
                                                                          on
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  color:
                                                                                    "grey-700",
                                                                                  size: "24",
                                                                                },
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "mdi-dots-vertical"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c(
                                                              "v-list",
                                                              {
                                                                staticClass:
                                                                  "pa-0",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item",
                                                                  {
                                                                    staticClass:
                                                                      "px-3",
                                                                    attrs: {
                                                                      ripple: false,
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.downloadCSV(
                                                                            item.batch_id
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-list-item-title",
                                                                      {
                                                                        staticClass:
                                                                          "body-1 grey-500--text d-flex align-center",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "grey-700",
                                                                                size: "20",
                                                                                left: "",
                                                                              },
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-file-document"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          "Descargar " +
                                                                            _vm._s(
                                                                              _vm
                                                                                .$store
                                                                                ?.state
                                                                                ?.auth
                                                                                ?.account
                                                                                ?.country ===
                                                                                "PE"
                                                                                ? "CSV"
                                                                                : "errores"
                                                                            )
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                      ],
                ],
                2
              ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: _vm.widthModalCreateErrors,
            persistent: "",
            "no-click-animation": "",
          },
          model: {
            value: _vm.dialogCreate,
            callback: function ($$v) {
              _vm.dialogCreate = $$v
            },
            expression: "dialogCreate",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [_vm._v("Crear proceso de emisión por lote")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      ;(_vm.dialogCreate = false),
                                        (_vm.errors = []),
                                        _vm.clearInput()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "pl-5 py-4" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2 pb-2", attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "3" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/backgrounds/modal-folios-upload.svg`),
                            height: 148,
                          },
                        }),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pr-0 pl-8" },
                        [
                          _c(
                            "v-list",
                            { staticClass: "v-list-form pa-0 transparent" },
                            [
                              _c(
                                "v-list-item",
                                { staticClass: "py-0" },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "d-flex align-center" },
                                    [
                                      _vm._v("Archivo "),
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            color: "grey-background",
                                            right: "",
                                            "max-width": "250px",
                                            transition: "scale-transition",
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      {
                                                        attrs: {
                                                          right: "",
                                                          small: "",
                                                          color: "grey-700",
                                                        },
                                                      },
                                                      on
                                                    ),
                                                    [_vm._v("mdi-information")]
                                                  ),
                                                ]
                                              },
                                            },
                                          ]),
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "d-block px-3 py-2",
                                            },
                                            [
                                              _vm._v(
                                                "Debes cargar un archivo comprimido (.zip .txt) o un .xlsx con las tramas de los documentos que deseas emitir "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item-subtitle",
                                    { staticClass: "ml-n16 pr-10" },
                                    [
                                      _c("v-file-input", {
                                        ref: "file",
                                        staticClass: "file-custom",
                                        attrs: {
                                          error: _vm.errorFile,
                                          type: "file",
                                          accept:
                                            _vm.$store?.state?.auth?.account
                                              ?.country === "PE"
                                              ? ".zip, .txt"
                                              : ".zip, .txt, .xlsx",
                                          prepend: "mdi-paper-clip",
                                          "hide-details": "",
                                          "background-color": "transparent",
                                          placeholder:
                                            "No se eligió ningún archivo",
                                          solo: "",
                                          flat: "",
                                          chips: "",
                                          dense: "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.setUploadFile()
                                          },
                                        },
                                        model: {
                                          value: _vm.file,
                                          callback: function ($$v) {
                                            _vm.file = $$v
                                          },
                                          expression: "file",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-4 px-5" },
                [
                  _c("v-spacer"),
                  !_vm.errors.length
                    ? _c(
                        "v-btn",
                        {
                          attrs: { outlined: "", color: "grey-700" },
                          on: {
                            click: function ($event) {
                              ;(_vm.dialogCreate = false), _vm.clearInput()
                            },
                          },
                        },
                        [_vm._v("Cancelar")]
                      )
                    : _vm._e(),
                  _vm.errors.length
                    ? _c(
                        "v-btn",
                        {
                          attrs: { outlined: "", color: "grey-700" },
                          on: {
                            click: function ($event) {
                              ;(_vm.errors = []), _vm.clearInput()
                            },
                          },
                        },
                        [_vm._v("Volver a subir")]
                      )
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: !_vm.errors.length
                          ? _vm.$store.state.batch.createLoader
                          : false,
                        disabled:
                          !!_vm.errorFile ||
                          !((_vm.file || {}).name || "").length,
                        color: "grey-900",
                      },
                      on: {
                        click: function ($event) {
                          !_vm.errors.length
                            ? _vm.createDocumentsBulk()
                            : _vm.handleDialog()
                        },
                      },
                    },
                    [_vm._v("Continuar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            width: "692",
            persistent: "",
            "no-click-animation": "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogExport,
            callback: function ($$v) {
              _vm.dialogExport = $$v
            },
            expression: "dialogExport",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [_vm._v("Descarga de emisión por lotes")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "retain-focus-on-click": "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.dialogExport = false
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: { color: "grey-500", size: "20" },
                                    },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-5 grey-500--text" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2 pb-4", attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "3" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/backgrounds/modal-export-fl.svg`),
                            width: 168,
                          },
                        }),
                      ]),
                      _c("v-col", { staticClass: "pr-4 pl-10 subtitle-2" }, [
                        _c("span", { staticClass: "d-block body-1 pt-2" }, [
                          _vm._v(
                            "Solo se descargarán los registros visibles en pantalla. Asegúrate de ir hasta el final de la tabla para realizar una descarga completa."
                          ),
                        ]),
                        _c(
                          "span",
                          { staticClass: "d-block font-weight-bold mt-5" },
                          [_vm._v("Resumen de la exportación")]
                        ),
                        _c(
                          "span",
                          { staticClass: "d-block body-1 mt-4 mb-3" },
                          [
                            _vm._v(
                              "Exportando: " +
                                _vm._s(_vm.batchesList?.length ?? 0) +
                                " registros"
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "py-2 px-5" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          _vm.dialogExport = false
                        },
                      },
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey-900" },
                      on: { click: _vm.exportTableToCSV },
                    },
                    [_vm._v("Descargar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }